<template>
    <div class="auth-form__user-type">
        <label class="auth-form__choice" for="user_type_person">
            <input
                id="user_type_person"
                class="auth-form__checkbox"
                type="radio"
                value="person"
                name="user_type"
                :checked="modelValue != 'company'"
                @input="updateValue($event.target.value)"
            >
            Osoba prywatna
        </label>
        <label class="auth-form__choice" for="user_type_company">
            <input
                id="user_type_company"
                class="auth-form__checkbox"
                type="radio"
                value="company"
                name="user_type"
                :checked="modelValue == 'company'"
                @input="updateValue($event.target.value)"
            >
            Firma
        </label>
        <ul class="form-field__error" v-if="errors">
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['name', 'errorMessages', 'modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            if (this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },
    },
    data() {
        return {
            value: '',
        };
    },
    computed: {
        errors: function () {
            if (this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        },
    },
    watch: {
        errorMessages: function () {
            this.value = '';
        },
    },
};
</script>
